import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPPhotos from 'data-hooks/usePDPPhotos/index';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import { FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, orientationOptionIds } from 'commons/constants';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import usePDPDeepLinkVariantMismatch from 'components/consumer/PDP/hooks/usePDPDeepLinkVariantMismatch';
import PDPDesktopHeroGalleryUI from './PDPDesktopHeroGalleryUI';
const EMPTY_ARRAY = [];
const PDPDesktopHeroGallery = t0 => {
  const $ = _c(82);
  const {
    isEditOrder: t1,
    mainPhotoLink,
    mode: t2,
    pdpIsModularBYOProduct,
    slug,
    productHeroImage: t3,
    productCylindoHeroImage: t4,
    hideProductLabel: t5
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productHeroImage = t3 === undefined ? null : t3;
  const productCylindoHeroImage = t4 === undefined ? null : t4;
  const hideProductLabel = t5 === undefined ? false : t5;
  const {
    loading,
    error,
    data,
    actions
  } = usePDPPhotos(null, slug);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const t6 = !pdpIsModularBYOProduct;
  let t7;
  if ($[0] !== t6) {
    t7 = {
      skip: t6
    };
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let modularPhotosData = useModularPDPPhotos(null, slug, t7);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const {
    resetGalleryImageTracking,
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  const {
    data: t8
  } = usePDPOptions();
  const {
    selectedOptionsExtended
  } = t8 === undefined ? {} : t8;
  const t9 = mode === "pdp";
  let t10;
  if ($[2] !== t9) {
    t10 = {
      isPDPDesktop: true,
      deferCylindoFetch: t9
    };
    $[2] = t9;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    cylindoConfigurationPhotos,
    isMechanicalOpen,
    toggleMechanicalOpen,
    isCylindoConfigurationPhotos,
    dimensionShotUrls,
    currentDimensionShot,
    selectedDimensionShotIndex,
    shouldShowDimensionThumbnail,
    setSelectedDimensionShotIndex
  } = usePDPCylindoViewer(t10);
  let t11;
  if ($[4] !== data || $[5] !== modularPhotosData?.data || $[6] !== pdpIsModularBYOProduct) {
    t11 = pdpIsModularBYOProduct ? modularPhotosData?.data ?? {} : data;
    $[4] = data;
    $[5] = modularPhotosData?.data;
    $[6] = pdpIsModularBYOProduct;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const {
    campaign,
    configurationPhotos: nonCylindoConfigurationPhotos,
    dimensionalImage,
    enableCrops,
    introVideoIds,
    isConfigFlipped,
    isVideoSelected,
    productName,
    selectedPhoto,
    studioPhotos: allStudioPhotos
  } = t11;
  const configurationPhotos = useRemoveBrokenImageUrls(isCylindoConfigurationPhotos ? cylindoConfigurationPhotos : nonCylindoConfigurationPhotos);
  const studioPhotos = useRemoveBrokenImageUrls(allStudioPhotos);
  let t12;
  if ($[8] !== actions || $[9] !== modularPhotosData?.actions || $[10] !== pdpIsModularBYOProduct) {
    t12 = pdpIsModularBYOProduct ? modularPhotosData?.actions ?? {} : actions;
    $[8] = actions;
    $[9] = modularPhotosData?.actions;
    $[10] = pdpIsModularBYOProduct;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const {
    setSelectedPhoto,
    setIsVideoSelected
  } = t12;
  const t13 = productCylindoHeroImage?.defaultUpholsteryValue;
  const t14 = productCylindoHeroImage?.defaultOrientation;
  let t15;
  if ($[12] !== t13 || $[13] !== t14) {
    t15 = {
      defaultUpholsteryValue: t13,
      defaultOrientation: t14
    };
    $[12] = t13;
    $[13] = t14;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  const isUrlDeepLinkMismatch = usePDPDeepLinkVariantMismatch(t15);
  let t16;
  bb0: {
    if (isUrlDeepLinkMismatch) {
      t16 = true;
      break bb0;
    }
    if (!productCylindoHeroImage?.src) {
      t16 = false;
      break bb0;
    }
    const norm = _temp;
    const selectedUpholstery = selectedOptionsExtended?.[FABRIC_PRODUCT_OPTION_ID]?.value || selectedOptionsExtended?.[LEATHER_PRODUCT_OPTION_ID]?.value || null;
    const selectedSku = selectedUpholstery?.sku != null ? String(selectedUpholstery.sku) : null;
    const defaultSku = productCylindoHeroImage.defaultUpholsterySku != null ? String(productCylindoHeroImage.defaultUpholsterySku) : null;
    const upholsteryMatches = selectedSku && defaultSku ? selectedSku === defaultSku : norm(selectedUpholstery?.value) === norm(productCylindoHeroImage.defaultUpholsteryValue);
    const selectedOrientationId = orientationOptionIds.find(id => selectedOptionsExtended?.[id]);
    const selectedOrientation = selectedOrientationId ? selectedOptionsExtended?.[selectedOrientationId]?.value?.value : null;
    const orientationMatches = norm(selectedOrientation) === norm(productCylindoHeroImage.defaultOrientation);
    t16 = !(upholsteryMatches && orientationMatches);
  }
  const isNonDefaultCylindoVariant = t16;
  let t17;
  bb1: {
    if (selectedPhoto?.type === "dimensional") {
      if (currentDimensionShot) {
        let t18;
        if ($[15] !== currentDimensionShot.dimensionCode || $[16] !== currentDimensionShot.src || $[17] !== selectedPhoto) {
          t18 = {
            ...selectedPhoto,
            src: currentDimensionShot.src,
            dimensionCode: currentDimensionShot.dimensionCode
          };
          $[15] = currentDimensionShot.dimensionCode;
          $[16] = currentDimensionShot.src;
          $[17] = selectedPhoto;
          $[18] = t18;
        } else {
          t18 = $[18];
        }
        t17 = t18;
        break bb1;
      }
      if (dimensionalImage?.src) {
        let t18;
        if ($[19] !== dimensionalImage.src || $[20] !== selectedPhoto) {
          t18 = {
            ...selectedPhoto,
            src: dimensionalImage.src
          };
          $[19] = dimensionalImage.src;
          $[20] = selectedPhoto;
          $[21] = t18;
        } else {
          t18 = $[21];
        }
        t17 = t18;
        break bb1;
      }
      t17 = selectedPhoto;
      break bb1;
    }
    if (isCylindoConfigurationPhotos && selectedPhoto?.type === "cylindo") {
      t17 = selectedPhoto;
      break bb1;
    }
    if (productCylindoHeroImage?.src && !isNonDefaultCylindoVariant && !isCylindoConfigurationPhotos && selectedPhoto?.type !== "studio") {
      let t18;
      if ($[22] !== productCylindoHeroImage.src) {
        t18 = {
          type: "cylindo",
          id: productCylindoHeroImage.src,
          src: productCylindoHeroImage.src
        };
        $[22] = productCylindoHeroImage.src;
        $[23] = t18;
      } else {
        t18 = $[23];
      }
      t17 = t18;
      break bb1;
    }
    if (isCylindoAvailable && !selectedPhoto) {
      if (isCylindoConfigurationPhotos) {
        t17 = cylindoConfigurationPhotos[0];
        break bb1;
      }
      let t18;
      if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = {
          type: "cylindo"
        };
        $[24] = t18;
      } else {
        t18 = $[24];
      }
      t17 = t18;
      break bb1;
    }
    const resolved = selectedPhoto || studioPhotos[0];
    if (resolved?.src || resolved?.type === "dimensional" || resolved?.type === "cylindo") {
      t17 = resolved;
      break bb1;
    }
    if (productHeroImage?.src) {
      let t18;
      if ($[25] !== productHeroImage.src) {
        t18 = {
          type: "studio",
          id: productHeroImage.src,
          src: productHeroImage.src
        };
        $[25] = productHeroImage.src;
        $[26] = t18;
      } else {
        t18 = $[26];
      }
      t17 = t18;
      break bb1;
    }
    t17 = resolved;
  }
  const selectedPhotoToShow = t17;
  let t18;
  if ($[27] !== dimensionShotUrls || $[28] !== dimensionalImage || $[29] !== selectedPhoto?.type) {
    t18 = () => {
      if (dimensionShotUrls.length) {
        return dimensionShotUrls;
      }
      if (selectedPhoto?.type === "dimensional" && dimensionalImage?.src) {
        return [{
          src: dimensionalImage.src,
          dimensionCode: "static",
          id: "static-dimensional"
        }];
      }
      return EMPTY_ARRAY;
    };
    $[27] = dimensionShotUrls;
    $[28] = dimensionalImage;
    $[29] = selectedPhoto?.type;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  selectedPhoto?.type;
  let t19;
  if ($[31] !== t18) {
    t19 = t18();
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  const dimensionShotsToShow = t19;
  const showCylindoSsrHero = !isNonDefaultCylindoVariant && !!productCylindoHeroImage?.src;
  const ssrHeroSrc = showCylindoSsrHero ? productCylindoHeroImage.src : !isUrlDeepLinkMismatch && productHeroImage?.src || null;
  const hasPhotos = !!studioPhotos?.length || !!configurationPhotos?.length;
  if (loading && !ssrHeroSrc && !hasPhotos) {
    const t20 = pdpSelectedCustomizerTab === "decide-later";
    let t21;
    if ($[33] !== hideProductLabel || $[34] !== mode || $[35] !== t20) {
      t21 = <PDPDesktopHeroGalleryUI loading={true} mode={mode} hideProductLabel={hideProductLabel} showDecideLaterOverlay={t20} />;
      $[33] = hideProductLabel;
      $[34] = mode;
      $[35] = t20;
      $[36] = t21;
    } else {
      t21 = $[36];
    }
    return t21;
  }
  if (!data) {
    if (ssrHeroSrc) {
      const t20 = showCylindoSsrHero ? "cylindo" : "studio";
      let t21;
      if ($[37] !== ssrHeroSrc || $[38] !== t20) {
        t21 = {
          type: t20,
          id: ssrHeroSrc,
          src: ssrHeroSrc
        };
        $[37] = ssrHeroSrc;
        $[38] = t20;
        $[39] = t21;
      } else {
        t21 = $[39];
      }
      const t22 = pdpSelectedCustomizerTab === "decide-later";
      let t23;
      if ($[40] !== hideProductLabel || $[41] !== isEditOrder || $[42] !== mode || $[43] !== pdpIsModularBYOProduct || $[44] !== t21 || $[45] !== t22) {
        t23 = <PDPDesktopHeroGalleryUI selectedPhoto={t21} loading={false} mode={mode} hideProductLabel={hideProductLabel} showDecideLaterOverlay={t22} pdpIsModularBYOProduct={pdpIsModularBYOProduct} isEditOrder={isEditOrder} />;
        $[40] = hideProductLabel;
        $[41] = isEditOrder;
        $[42] = mode;
        $[43] = pdpIsModularBYOProduct;
        $[44] = t21;
        $[45] = t22;
        $[46] = t23;
      } else {
        t23 = $[46];
      }
      return t23;
    }
    return null;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  const t20 = pdpSelectedCustomizerTab === "decide-later";
  let t21;
  if ($[47] !== cylindoConfigurationPhotos || $[48] !== setSelectedPhoto) {
    t21 = t22 => {
      const {
        id: id_0,
        index,
        src,
        type
      } = t22;
      if (type === "cylindo") {
        setSelectedPhoto?.(cylindoConfigurationPhotos[index] ?? null);
        return;
      }
      setSelectedPhoto?.({
        id: id_0,
        index,
        src,
        type
      });
    };
    $[47] = cylindoConfigurationPhotos;
    $[48] = setSelectedPhoto;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  const t22 = !isCylindoAvailable;
  let t23;
  if ($[50] !== campaign || $[51] !== configurationPhotos || $[52] !== cylindoFeatures || $[53] !== dimensionShotUrls || $[54] !== dimensionShotsToShow || $[55] !== dimensionalImage || $[56] !== enableCrops || $[57] !== hideProductLabel || $[58] !== introVideoIds || $[59] !== isConfigFlipped || $[60] !== isCylindoAvailable || $[61] !== isCylindoConfigurationPhotos || $[62] !== isEditOrder || $[63] !== isMechanicalOpen || $[64] !== isVideoSelected || $[65] !== mainPhotoLink || $[66] !== mode || $[67] !== pdpIsModularBYOProduct || $[68] !== productName || $[69] !== resetGalleryImageTracking || $[70] !== selectedDimensionShotIndex || $[71] !== selectedPhotoToShow || $[72] !== setIsVideoSelected || $[73] !== setSelectedDimensionShotIndex || $[74] !== shouldShowDimensionThumbnail || $[75] !== studioPhotos || $[76] !== t20 || $[77] !== t21 || $[78] !== t22 || $[79] !== toggleMechanicalOpen || $[80] !== viewGalleryImageEvent) {
    t23 = <PDPDesktopHeroGalleryUI configurationPhotos={configurationPhotos} isMechanicalOpen={isMechanicalOpen} toggleMechanicalOpen={toggleMechanicalOpen} selectedPhoto={selectedPhotoToShow} dimensionsImage={dimensionalImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} isEditOrder={isEditOrder} enableCrops={enableCrops} loading={false} showDecideLaterOverlay={t20} setSelectedPhoto={t21} dimensionShotUrls={dimensionShotUrls} dimensionShotsToShow={dimensionShotsToShow} selectedDimensionShotIndex={selectedDimensionShotIndex} setSelectedDimensionShotIndex={setSelectedDimensionShotIndex} studioPhotos={studioPhotos} isConfigFlipped={isConfigFlipped} introVideoIds={introVideoIds} isVideoSelected={isVideoSelected} setIsVideoSelected={setIsVideoSelected} productName={productName} cylindoFeatures={cylindoFeatures} isCylindoAvailable={isCylindoAvailable} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} resetGalleryImageTracking={resetGalleryImageTracking} viewGalleryImageEvent={viewGalleryImageEvent} pdpIsModularBYOProduct={pdpIsModularBYOProduct} mode={mode} hideProductLabel={hideProductLabel} mainPhotoLink={mainPhotoLink} campaign={campaign} displayOnlyConfigImages={t22} />;
    $[50] = campaign;
    $[51] = configurationPhotos;
    $[52] = cylindoFeatures;
    $[53] = dimensionShotUrls;
    $[54] = dimensionShotsToShow;
    $[55] = dimensionalImage;
    $[56] = enableCrops;
    $[57] = hideProductLabel;
    $[58] = introVideoIds;
    $[59] = isConfigFlipped;
    $[60] = isCylindoAvailable;
    $[61] = isCylindoConfigurationPhotos;
    $[62] = isEditOrder;
    $[63] = isMechanicalOpen;
    $[64] = isVideoSelected;
    $[65] = mainPhotoLink;
    $[66] = mode;
    $[67] = pdpIsModularBYOProduct;
    $[68] = productName;
    $[69] = resetGalleryImageTracking;
    $[70] = selectedDimensionShotIndex;
    $[71] = selectedPhotoToShow;
    $[72] = setIsVideoSelected;
    $[73] = setSelectedDimensionShotIndex;
    $[74] = shouldShowDimensionThumbnail;
    $[75] = studioPhotos;
    $[76] = t20;
    $[77] = t21;
    $[78] = t22;
    $[79] = toggleMechanicalOpen;
    $[80] = viewGalleryImageEvent;
    $[81] = t23;
  } else {
    t23 = $[81];
  }
  return t23;
};
PDPDesktopHeroGallery.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  mainPhotoLink: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
  hideProductLabel: PropTypes.bool,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string,
    // The default selection this frame represents, so the gallery can confirm the current
    // (URL/user) selection still matches before painting it as the SSR LCP (CON-8293).
    defaultUpholsteryValue: PropTypes.string,
    defaultUpholsterySku: PropTypes.string,
    defaultOrientation: PropTypes.string
  })
};
export default PDPDesktopHeroGallery;
function _temp(value) {
  return value == null ? null : String(value).trim().toLowerCase();
}